var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#1A1A1A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1141 12.9945C10.1138 12.8501 10.1725 12.7102 10.2801 12.599L13.8894 8.89121C14.0119 8.76501 14.188 8.68565 14.3789 8.67058C14.5697 8.65552 14.7598 8.70598 14.9072 8.81087C15.0546 8.91577 15.1473 9.0665 15.1649 9.2299C15.1825 9.39331 15.1236 9.55601 15.001 9.68221L11.7672 12.9945L14.8855 16.3068C14.9455 16.37 14.9903 16.4427 15.0173 16.5208C15.0443 16.5989 15.0531 16.6808 15.043 16.7617C15.0329 16.8427 15.0043 16.9212 14.9587 16.9926C14.9131 17.0641 14.8514 17.1271 14.7773 17.1781C14.703 17.2347 14.616 17.2776 14.5215 17.304C14.427 17.3305 14.3272 17.3399 14.2283 17.3318C14.1293 17.3237 14.0334 17.2982 13.9465 17.2568C13.8596 17.2155 13.7837 17.1593 13.7234 17.0916L10.2368 13.3838C10.1462 13.2694 10.103 13.1324 10.1141 12.9945V12.9945Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.ce99c4ca6fba329d069d9974d55723a7.svg";
export { ForwardRef as ReactComponent };